module.exports = __webpack_public_path__ + "da8fff0b8f2087178706d0e9fe03c266.png";